import { render, staticRenderFns } from "./ModalTopup.vue?vue&type=template&id=6c6cb466"
import script from "./ModalTopup.vue?vue&type=script&lang=js"
export * from "./ModalTopup.vue?vue&type=script&lang=js"
import style0 from "./ModalTopup.vue?vue&type=style&index=0&id=6c6cb466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports